/* MAB Prio 10 – Zustelldatum-Berechnung (v3)
   Läuft global, einmalig geladen via assets.
   Reagiert auf initiales Laden UND renderProductInfo()-Swaps.
   v3: Single-Date-Anzeige, Feiertage DE+AT (rollierend via Gauß-Osterformel).
   i18n: Wochentage via Intl.DateTimeFormat, Labels via data-Attribute. */
(function() {
  'use strict';

  /* Gauß'sche Osterformel — gültig 1583–8202 */
  function getEaster(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }

  /* Bundesweite Feiertage DE + AT.
     Für Versandlogistik (DPD) reichen bundesweite — Bundesländer-Spezifika
     wie Fronleichnam in DE oder Karfreitag in AT bewusst nicht abgebildet. */
  function isHoliday(date, country) {
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var key = m + '-' + d;

    /* Beide Länder, fix */
    if (key === '1-1' || key === '5-1' || key === '12-25' || key === '12-26') {
      return true;
    }

    /* DE bundesweit, fix */
    if (country === 'DE' && key === '10-3') return true;

    /* AT bundesweit, fix */
    if (country === 'AT') {
      if (key === '1-6' || key === '8-15' || key === '10-26' ||
          key === '11-1' || key === '12-8') return true;
    }

    /* Bewegliche Feiertage relativ zu Ostersonntag */
    var easter = getEaster(date.getFullYear());
    var diff = Math.round(
      (date.setHours(0,0,0,0) - easter.setHours(0,0,0,0)) / 86400000
    );

    if (country === 'DE' && diff === -2) return true;       /* Karfreitag */
    if (diff === 1) return true;                            /* Ostermontag (DE+AT) */
    if (diff === 39) return true;                           /* Christi Himmelfahrt (DE+AT) */
    if (diff === 50) return true;                           /* Pfingstmontag (DE+AT) */
    if (country === 'AT' && diff === 60) return true;       /* Fronleichnam (AT bundesweit) */

    return false;
  }

  function isBusinessDay(date, country) {
    var dow = date.getDay();
    if (dow === 0 || dow === 6) return false;
    if (isHoliday(new Date(date), country)) return false;
    return true;
  }

  function addBusinessDays(date, days, country) {
    var result = new Date(date);
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (isBusinessDay(result, country)) added++;
    }
    return result;
  }

  function getShipDate(country) {
    var now = new Date();
    var hour = now.getHours();
    var todayBiz = isBusinessDay(now, country);

    if (todayBiz && hour < 14) {
      return now;
    }

    var next = new Date(now);
    do {
      next.setDate(next.getDate() + 1);
    } while (!isBusinessDay(next, country));
    return next;
  }

  function formatDate(date) {
    /* Locale-sensitive short weekday via Intl API */
    var lang = document.documentElement.lang || 'de';
    var weekday = date.toLocaleDateString(lang, { weekday: 'short' });
    weekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);
    weekday = weekday.replace(/\.$/, '');

    var d = String(date.getDate()).padStart(2, '0');
    var m = String(date.getMonth() + 1).padStart(2, '0');
    return weekday + '. ' + d + '.' + m + '.';
  }

  function updateDeliveryDates() {
    var elements = document.querySelectorAll('[data-delivery-dates]:not([data-dates-done])');
    elements.forEach(function(el) {
      var minDays = parseInt(el.dataset.minDays, 10);
      var maxDays = parseInt(el.dataset.maxDays, 10);
      var country = (el.dataset.country || 'AT').toUpperCase();
      if (isNaN(minDays)) return;

      var labelDelivery = el.dataset.tDelivery || 'Zustellung';

      var shipDate = getShipDate(country);
      var earliest = addBusinessDays(shipDate, minDays, country);

      /* Single-date display: nur frühestes Datum */
      el.textContent = labelDelivery + ' ' + formatDate(earliest);

      /* Spätestes Datum als data-Attribut, kann von Tooltip genutzt werden */
      if (!isNaN(maxDays) && maxDays > minDays) {
        var latest = addBusinessDays(shipDate, maxDays, country);
        el.setAttribute('data-latest-date', formatDate(latest));
      }

      el.setAttribute('data-dates-done', '');
    });
  }

  /* Initial */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateDeliveryDates);
  } else {
    updateDeliveryDates();
  }

  /* Nach Variantenwechsel: MutationObserver auf Product-Section */
  var container = document.getElementById('shopify-section-main-product')
               || document.querySelector('.main-product');
  if (container) {
    new MutationObserver(function() {
      updateDeliveryDates();
    }).observe(container, { childList: true, subtree: true });
  }
})();
